import unit from './unit';

export default function decibel(value, decimals = 2) {
  return unit(value, 'dB', decimals);
}
